import React, { useCallback, useEffect } from 'react';
import useCheckPermissions from 'hooks/auth/useCheckPermission';
import { Checkbox } from 'components/ui';
import { PERMISSIONS } from 'constants/auth';

type RateLimitCheckBoxType = {
  checked: boolean | null,
  setChecked: (checked: boolean) => void,
};

export default function RateLimitCheckBox(props: RateLimitCheckBoxType) {
  const { checked, setChecked } = props;

  const { userCheckPermission } = useCheckPermissions();
  const userHasPermission = userCheckPermission(PERMISSIONS.RATE_LIMIT);

  const onChange = () => setChecked(!checked);

  const setCheckedCB = useCallback(setChecked, [checked]);

  useEffect(() => {
    // when checked is null, the template is new and hence we set is rate_limit as true for admin users
    if (checked === null) setCheckedCB(userHasPermission);
  }, [checked]);

  return (
    <Checkbox
      checked={!!checked}
      disabled={!userHasPermission}
      onChange={onChange}
    >
      Relax Throttling
    </Checkbox>
  );
}
